import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { useSmartBack } from '@/composables/use-smart-back'
import {
  Col as VanCol,
  Icon as VanIcon,
  NavBar as VanNavBar,
  Picker as VanPicker,
  Popup as VanPopup,
  Row as VanRow,
  Tab as VanTab,
  Tabs as VanTabs,
} from 'vant'
import { useRegionStore } from '@/stores/region-store'
import { useVideoStore } from '@/stores/video-store'
import { useSeo, useSiteBrand } from '@/composables/use-seo'
import { lotteryName } from '@/utils/seo'
import { getApiV1LotteryYears } from '@/api/sdk.gen'
import type { LotteryType } from '@/stores/region-store'
import emptyImg from '@/assets/empty-data.png'

export default defineComponent({
  name: 'VideoListPage',
  setup() {
    const route = useRoute()
  const goBack = useSmartBack()
    const regionStore = useRegionStore()
    const videoStore = useVideoStore()

    const dateShow = ref(false)
    const yearColumns = ref<{ text: string; value: number }[]>([])

    // SEO：开奖回放列表页，随彩种动态（站点名取后台配置）
    const brand = useSiteBrand()
    const lotName = computed(() => lotteryName(regionStore.lotteryType))
    useSeo({
      title: () => `${lotName.value}开奖视频回放_历史开奖现场回放 - ${brand.value}`,
      description: () =>
        `${lotName.value}历史开奖视频回放，按年份与期号查看历期开奖现场录像与开奖号码。`,
      keywords: () => `${lotName.value},开奖回放,视频回放,开奖现场,历史开奖,${brand.value}`,
    })

    async function fetchYears() {
      const res = await getApiV1LotteryYears({ query: { region: regionStore.region } })
      const years = res.data?.data ?? []
      yearColumns.value = years.map((y) => ({ text: `${y}年`, value: y }))
      if (years.length > 0 && !years.includes(videoStore.selectedYear)) {
        videoStore.selectedYear = years[0]!
      }
    }

    function handleTabChange(name: LotteryType) {
      regionStore.setLotteryType(name)
    }

    function onPickerConfirm({ selectedValues }: { selectedValues: number[] }) {
      dateShow.value = false
      const year = selectedValues[0]
      if (year != null && year !== videoStore.selectedYear) {
        videoStore.fetchAll(year)
      }
    }

    onMounted(async () => {
      const type = route.query.type
      if (type === 'hk' || type === 'macau') regionStore.setLotteryType(type)
      await fetchYears()
      await videoStore.fetchAll()
    })

    watch(
      () => regionStore.region,
      async () => {
        await fetchYears()
        await videoStore.fetchAll()
      },
    )

    return () => (
      <div class="m-scene-play">
        <div class="m-scene-play-body">
          <VanNavBar title="开奖回放" fixed placeholder>
            {{
              left: () => (
                <VanIcon name="arrow-left" color="#333" size="16" onClick={() => goBack()} />
              ),
              right: () => (
                <VanIcon
                  name="notes-o"
                  color="#07c160"
                  size="16"
                  onClick={() => (dateShow.value = true)}
                />
              ),
            }}
          </VanNavBar>
          <div style="padding:10px 0">
            <VanTabs
              type="card"
              class="new-van-tabs"
              active={regionStore.lotteryType}
              onUpdate:active={(v: LotteryType) => handleTabChange(v)}
            >
              <VanTab name="macau" title="澳门六合彩" />
              <VanTab name="hk" title="香港六合彩" />
            </VanTabs>
          </div>
        </div>

        <div class="prize-list">
          <div class="bd-box">
            <VanRow gutter="20">
              {videoStore.videoList.map((item) => (
                <VanCol key={item.id} span={12}>
                  <RouterLink
                    class="item btn-reset block"
                    to={`/video/${item.period}?type=${regionStore.lotteryType}&year=${item.year}`}
                  >
                    <div class="image">
                      {/* referrerpolicy 必须写在 src 之前，参见 live.tsx 同处注释 */}
                      <img
                        referrerpolicy="no-referrer"
                        src={item.pictureUrl}
                        alt=""
                        class="w-full h-full object-cover block"
                      />
                    </div>
                    <div class="text">{item.videoTitle}</div>
                  </RouterLink>
                </VanCol>
              ))}
            </VanRow>
          </div>
        </div>

        {videoStore.videoList.length === 0 && !videoStore.loading && (
          <div class="text-center pt-[0.4rem] pb-[0.4rem]">
            <img src={emptyImg} class="w-[1.28rem]" alt="" />
            <p class="text-center text-[#a0a0a0] text-[0.32rem] leading-[0.44rem] mt-[0.28rem]">
              暂无回放
            </p>
          </div>
        )}

        <VanPopup
          show={dateShow.value}
          onUpdate:show={(v: boolean) => (dateShow.value = v)}
          position="bottom"
        >
          <VanPicker
            columns={yearColumns.value}
            title="选择年份"
            onConfirm={onPickerConfirm}
            onCancel={() => (dateShow.value = false)}
          />
        </VanPopup>
      </div>
    )
  },
})
